import api from 'services/api/api';

export enum LogStatusEnum {
	ERROR = 'ERROR',
	SUCCESS = 'SUCCESS',
	PROCESSING = 'PROCESSING',
	STARTED = 'STARTED',
}

export enum LogActionEnum {
	BULKCREATE = 'BULKCREATE',
}

export enum OrigemInformacaoEnum {
	EASY = 'EASY',
	BITEC = 'BITEC',
	PROCEDO = 'PROCEDO',
}

export interface CreateLogDto {
	origin: OrigemInformacaoEnum;
	action: LogActionEnum;
	eventUrl: string;
	status: LogStatusEnum;
	details?: Record<string, unknown>;
	uid?: string;
	date?: Date;
	sendEmail?: boolean;
}

export interface AsyncJobInfo {
	id: number;
	status: string;
	progress: number;
	status_label: string;
	process_type_label: string;
	download_url: string | null;
	result_description: string | null;
	start_date: Date | null;
	finish_date: Date | null;
}

export interface ResponseLogViewDto {
	id?: number;
	uid?: string;
	origem?: OrigemInformacaoEnum;
	status?: LogStatusEnum;
	data_hora?: Date;
	endpoint?: string;
	metodo?: string;
	modelo?: string;
	acao?: LogActionEnum;
	descricao_acao?: string;
	usuario_id?: number;
	nome_usuario?: string;
	usuario_email?: string;
	async_job?: AsyncJobInfo;
}

export const createLog = async (body: CreateLogDto) => {
	const response = await api.post('/log', {
		...body,
		status: body.status as string,
		details: body.details,
		date: body.date || new Date(),
	});
	return response.data;
};
